import React from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '@mui/material';
import DonutChartWithText from 'modules/Programs/components/Programs/PieChart/ChartWithText';

import { useServiceRouter } from '@common/components/ServiceRouter';
import { IStudentProgramModel } from '@common/models/StudentPrograms/StudentProgram';

interface PropsType {
	programModel: IStudentProgramModel;
}

function ProgramCourseInfoDonutChart({ programModel }: PropsType) {
	const { t } = useTranslation();
	const theme = useTheme();
	const { checkService } = useServiceRouter();

	return (
		<DonutChartWithText
			// index of missed + index of learnt
			{...(checkService('academy') && { combinedSegments: [[3, 4]] })}
			segments={[
				{
					value: programModel.visited,
					label: t('program.visited'),
					color: theme.palette.success.contrastText,
				},
				{
					value: programModel.planed_lessons,
					label: t('program.planned'),
					color: theme.palette.primary.main,
				},
				{
					value: programModel.presense_not_set,
					label: t('program.noStatus'),
					color: '#a37cdd',
				},
				{
					value: programModel.missed,
					label: t('program.missed'),
					color: theme.palette.error.contrastText,
				},
				...(checkService('academy')
					? [
							{
								value: programModel.learnt_lessons,
								label: t('program.learnt'),
								color: theme.palette.warning.contrastText,
							},
						]
					: []),
			]}
			size={195}
			strokeWidth={32}
			gap={1}
		/>
	);
}

export default ProgramCourseInfoDonutChart;
